import { BookText, Loader2 } from 'lucide-react'
import { MdArticle } from 'react-icons/md'
import { Link } from 'react-router-dom'

import { Button } from '@/modules/shared/components/ui/button'
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/modules/shared/components/ui/card'
import { Input } from '@/modules/shared/components/ui/input'

import type { useDocsList } from '../hooks/use-docs-list.hook'

type Props = ReturnType<typeof useDocsList>

export function DocListInterface({
	docs,
	initialDocs,
	isLoading,
	isInitialLoading,
	setQuery,
	handleFetchDocs,
	query,
}: Props) {
	return (
		<div className="min-h-[60vh]">
			<div className="flex gap-2">
				<Input
					placeholder="Escreva aqui o que você procura..."
					onChange={(e) => setQuery(e.currentTarget.value)}
				/>
				<Button onClick={handleFetchDocs} className="gap-2">
					{isLoading && <Loader2 className="animate-spin" width={22} />}
					Buscar
				</Button>
			</div>
			<div className="flex flex-1 flex-col gap-6 justify-center mt-10">
				{docs.length > 0 && query ? (
					<>
						{docs?.map((doc) => (
							<div key={doc.id} className="flex gap-2">
								<Link
									to={`/documentacao/${doc.slug}`}
									className="text-md grid grid-cols-12 gap-2"
								>
									<BookText className="text-red-500" width={20} />
									<h2 className="text-md col-span-11">{doc.title}</h2>
								</Link>
							</div>
						))}

						{docs.length === 0 && !isLoading && (
							<p className="mt-40 text-sm text-gray-400 text-center">
								Nenhum resultado encontrado.
							</p>
						)}
					</>
				) : (
					<Card>
						<CardHeader>
							<CardTitle>Guia Inicial</CardTitle>
							<CardDescription>
								Bem-vindo ao guia inicial. Explore os tutoriais essenciais para
								começar a usar o sistema.
							</CardDescription>
						</CardHeader>
						<CardContent>
							{isInitialLoading ? (
								<div className="flex justify-center p-6">
									<Loader2 className="animate-spin" size={24} />
								</div>
							) : initialDocs && initialDocs.length > 0 ? (
								<ul className="p-4 space-y-4">
									{initialDocs.map((doc) => (
										<li key={doc.id} className="flex items-center gap-2">
											<MdArticle size={20} className="text-primary" />
											<Link to={`/documentacao/${doc.slug}`}>
												{doc.title}
											</Link>
										</li>
									))}
								</ul>
							) : (
								<p className="p-4 text-gray-400 text-center">
									Nenhuma documentação disponível no momento.
								</p>
							)}
						</CardContent>
					</Card>
				)}
			</div>
		</div>
	)
}